import React,{useEffect, useState} from 'react';
import {Grid,Box,Theme,useMediaQuery,useTheme,Fab} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import DrDetails from '../drDetails';
import { useStore } from 'store/StoreProvider';
import { useSession } from 'hooks/SessionProvider';
import AppointmentForm from '../aptForm';
import DialogHeader from '../dialogHeder';
import SuccessAPT from '../successAPT';
import { motion } from 'framer-motion';
import { RouterView } from 'hooks/RouteProvider'; // Import hooks
import APTDetails from '../aptDetails';
import { customRoutes } from 'utils/constants';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

interface props {
  data?: any;
}

const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        dialogMain:{
            '& .MuiDialog-paper': {
               [theme.breakpoints.up('lg')]:{
                minWidth: '55%',
               },
                // width: '100%',
                // maxWidth: '90vw', // Adjust as needed to make it responsive
                marginLeft:"20px",
                marginRight:"20px",
                height:"85%",
                paddingLeft:"32px",
                paddingRight:"32px",
              },
        },
        DRDetailsMain:{
          [theme.breakpoints.up('lg')]:{
            height:"90%"
          },
          [theme.breakpoints.down('sm')]:{
            height:"100%"
          }
        },
        FullScreenMain:{
          width:"100%",
          paddingRight:"20px",
          paddingLeft:"20px",
          overflow:"hidden",
          backgroundColor:"#fff",
          borderRadius:"10px",
          [theme.breakpoints.down('sm')]:{
            maxHeight:"none !important"
          }
        }
        
    })
  );

const FullScreenAPT:React.FC<props>= ({data})=> {
    const store = useStore();
    const { isDateTimeSelected } = useSession();
    const classes = useStyles();
    const [open, setOpen] = useState(true);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    useEffect(()=>{
      store.setData(data)
    },[])
  
    const handleClose = () => {
      setOpen(false);
    };

    const scrollTop=()=>{
      const scrollableElement = document.querySelector('.appointment-widget'); // scrolling widget parent div using classname
        if (scrollableElement) {
          scrollableElement.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }


  return (
    <Box sx={{display:"flex",justifyContent:"center"}}>
        <Grid sx={{height:`${!isDateTimeSelected && !isSmallScreen && "83vh"}`}} className={classes.FullScreenMain}>
        <Grid>
          <DialogHeader handleClose={handleClose} BusinessDetails={data?.BusinessDetails}></DialogHeader>
        </Grid>

        <RouterView>
            {({ route }) => (
              <motion.div
                key={route}
                className={route === customRoutes.DRDetails ? classes.DRDetailsMain : ''}
                initial={{ opacity: 0}}
                animate={{ opacity: 1}}
                exit={{ opacity: 0 }}
              >
                {route === customRoutes.APTDetails && (
                  <APTDetails AppointmentTypes={data?.AppointmentTypes} Providers={data?.Providers} Addresses={data?.Addresses} Schedules={data?.Schedules} AppointmentTypeDoctors={data?.AppointmentTypeDoctors} />
                )}
                
                {route === customRoutes.DRDetails && (
                  <DrDetails Providers={data?.Providers} Schedules={data?.Schedules} AppointmentTypeDoctors={data?.AppointmentTypeDoctors} />
                )}
                {route === customRoutes.appointmentForm && (
                  <AppointmentForm />
                )}
                {route === customRoutes.successAPT && (
                  <SuccessAPT />
                )}
              </motion.div>
            )}
         </RouterView>

     {false ?
       <Grid sx={{position:"fixed",bottom:"100px",right:"20px"}} className='floating-action-button'>
          <Fab color="primary" aria-label="bottom-to-top" onClick={scrollTop}>
            <ArrowUpwardIcon />
          </Fab>
        </Grid>:null}

      </Grid>
    </Box>
  )
}

export default FullScreenAPT